import { Col, Collapse, Row } from "antd";
import React, { useState } from "react";
import TagComponent from "../../../../biblio/TagComponent";
import dayjs from "dayjs";
import parse from "html-react-parser";
import { FileOutlined } from "@ant-design/icons";
import PdfPreview from "../../../../biblio/Modal/PdfPreview";

interface Props {
  requests: any;
}
const ContactUsList = ({ requests }: Props) => {
  const [pdfUrl, setPdfUrl] = useState<string>("");
  return (
    <div className="takaful--collapse-profile-container">
      <div
        className={`takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services  `}
      >
        <Collapse.Panel
          showArrow={false}
          key="0"
          className=" takaful--collapse-label-panel"
          header={
            <div className="takaful--header-service-profile-container">
              <Row
                className="takaful--content-profile-box1"
                style={{ marginBottom: "0" }}
              >
                <Col
                  xxl={6}
                  xl={6}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    عنوان الطلب
                  </p>
                </Col>
                <Col
                  xxl={7}
                  xl={7}
                  lg={6}
                  md={6}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    تاريخ الطلب
                  </p>
                </Col>
                <Col
                  xxl={7}
                  xl={7}
                  lg={7}
                  md={7}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    نوع الطلب
                  </p>
                </Col>
                <Col
                  xxl={4}
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">المرحلة</p>
                </Col>
              </Row>
            </div>
          }
        ></Collapse.Panel>
      </div>
      <Collapse
        className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
        accordion
        defaultActiveKey={["0"]}
      >
        {requests?.map((element: any, index: number) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel"
            key={index}
            showArrow={false}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  align={"middle"}
                  className="takaful--content-profile-box1"
                  style={{ marginBottom: "0" }}
                >
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      عنوان الطلب
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.name}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      تاريخ الطلب
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.create_date
                        ? dayjs(element?.create_date, "YYYY-MM-DD").format(
                            "YYYY/MM/DD"
                          )
                        : ""}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      نوع الطلب
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.ticket_type_id}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={12}
                    xs={12}
                    className="takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      المرحلة
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <TagComponent
                      className="takaful--tag-component"
                      width="70%"
                      state={element?.state}
                      orangeValue="in_progress"
                      greenValue="done"
                      redValue="cancel"
                      text={
                        element.stage_id &&
                        element?.stage_id.length > 0 &&
                        element?.stage_id
                      }
                    />
                  </Col>
                </Row>
              </div>
            }
          >
            <Row
              className={`takaful--content-profile-box1`}
              justify={"space-between"}
              gutter={16}
            >
              <Col
                xxl={5}
                xl={5}
                lg={5}
                md={5}
                sm={8}
                xs={10}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">الوصف : </p>
              </Col>
              <Col
                xxl={6}
                xl={6}
                lg={6}
                md={6}
                sm={16}
                xs={14}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.description && parse(element?.description)}
                </span>
              </Col>

              <Col
                xxl={4}
                xl={4}
                lg={4}
                md={4}
                sm={8}
                xs={10}
                className="takaful--content-profile-col"
              >
                {element?.attachment_ids &&
                  element?.attachment_ids?.length > 0 && (
                    <p className="takaful--content-services-request-p">
                      المرفقات :
                    </p>
                  )}
              </Col>
              <Col
                xxl={9}
                xl={9}
                lg={9}
                md={9}
                sm={16}
                xs={14}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.attachment_ids.map(
                    (item: string, index: number) => (
                      <span className="takaful--content-services-request-span takaful--color-span">
                        <FileOutlined
                          className="takaful--download-icon takaful--service-download-icon"
                          onClick={(e) => {
                            setPdfUrl(item);
                          }}
                        />{" "}
                      </span>
                    )
                  )}
                </span>
              </Col>
            </Row>
          </Collapse.Panel>
        ))}
      </Collapse>
      <PdfPreview
        open={pdfUrl !== ""}
        onClose={() => setPdfUrl("")}
        url={pdfUrl}
        isBlob={false}
        className="takaful--pdf-preview-modal"
      />
    </div>
  );
};

export default ContactUsList;
